<template>
    <div class="o-mobile-map-qr mobile-qr">
        <div class="mobile-qr__info">
            <div class="mobile-qr__title">
                {{$t('ui.scan-code')}}
            </div>
            <div 
                class="mobile-qr__description"
                v-html="$t('ui.scan-code-description')"
            />
        </div>
        <div class="mobile-qr__icon"/>
        <div class="mobile-qr__qr-background"/>
        <div class="mobile-qr__qr-wrapper">
            <OQrCodeGenerator />
        </div>
    </div>
</template>

<script>
import OQrCodeGenerator from '../o-qr-code-generator/o-qr-code-generator'
export default {
    name: "OMobileMapQr",
    components: {
        OQrCodeGenerator
    }
}
</script>

<style lang="scss">
@import "theme";
</style>
